import { useContext, useEffect } from 'react';
import { SplashLoaderContext } from './SplashLoaderRoot';

let SplashLoader = () => {
  let { register } = useContext(SplashLoaderContext);

  useEffect(() => {
    return register();
  }, [register]);

  return null;
};

export default SplashLoader;
